export default __webpack_public_path__ + "static/media/playstation_card.ffbac8d0.svg";